import React, { useEffect } from 'react'
import { useNavigate } from 'react-router-dom';


// console.log(window.location.origin + localStorage.getItem("url"));

function Callback() {
    const navigate = useNavigate();
    useEffect(() => {
        // localStorage.getItem("iaam") //check login & logout
        if (window.location.search === "") {
            navigate(localStorage.getItem("url"));
            // console.log(localStorage.getItem("iaam"));
            // console.log(localStorage.getItem("iaam"));
            // if (localStorage.getItem("iaam")) {
            //     navigate(localStorage.getItem("url"));
            // } else {
            //     navigate("/");
            // }
        }
    }, [navigate])
    return (
        <></>
    )
}

export default Callback
